import { render, staticRenderFns } from "./CustomExtensionAccessModal.vue?vue&type=template&id=4b996333&"
import script from "./CustomExtensionAccessModal.vue?vue&type=script&lang=ts&"
export * from "./CustomExtensionAccessModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports